module.exports = __webpack_public_path__ + "img/vue2-doublure_rose.e94d5af7.png";